import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {GameH2hExtraDataApiModel} from "./game-h2h.extra-data.api-model";

export class GameH2hExtraDataDomainModel extends BaseDomainModel {
  num: Number;
  text: String;
  outcome: Number;

  constructor(model: GameH2hExtraDataApiModel) {
    super(model);

    this.num = model.num;
    this.text = model.text;
    this.outcome = model.outcome;
  }
}